import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const CHAT_TABS = {
  chatHistory: "All Chat",
  favourite: "Favorites",
  archive: "Archived",
} as const;
export type ChatHistoryTab = keyof typeof CHAT_TABS;

interface InitialState {
  activeTab: ChatHistoryTab;
  title: string;
  tabs: typeof CHAT_TABS;
}
const initialState: InitialState = {
  activeTab: "chatHistory",
  title: CHAT_TABS.chatHistory,
  tabs: CHAT_TABS,
};

const chatHistoryActionSlice = createSlice({
  name: "chatHistoryAction",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<ChatHistoryTab>) => {
      state.activeTab = action.payload;
      state.title = CHAT_TABS[action.payload];
    },
  },
});
export const { setActiveTab } = chatHistoryActionSlice.actions;
export default chatHistoryActionSlice.reducer;
